export default __webpack_public_path__ + "static/media/ELECTIVES_HEALTH.e302631c.svg";